module.exports = __webpack_public_path__ + "media/images/faces/male/15-d842cd52c207a63cf271d437c478edf4.jpg";